module.exports = __webpack_public_path__ + "static/media/nuevoInforme-1.116039c7.jpg";